import { Box, Typography } from '@mui/material'
import { BrandModelSearch } from '../EquipmentActionCard/BrandModelSearch'

export const Step3RefrigeratorBranch = () => (
  <Box
    sx={{
      p: 3,
      borderRadius: 1.5,
      border: '1px solid',
      borderColor: 'divider',
      bgcolor: 'background.paper',
    }}
  >
    <Typography variant="h5" sx={{ mb: 1 }}>
      Let&apos;s find your filter.
    </Typography>
    <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
      Enter your fridge brand and model — we&apos;ll match you to the right replacement and keep it stocked. Free service.
    </Typography>
    <BrandModelSearch />
  </Box>
)
